import axios from 'axios';
import qs from 'qs';
import sha1 from 'crypto-js/sha1';
import md5 from 'crypto-js/md5';
import store from '@/store';
import envConfig from '../../config';
import { Toast } from 'vant';
import { USER_USERINFO_UPDATE } from '@/store/mutationTypes';
import { randomUUID } from 'cfmoto-utils';
import { getCustomAgent } from '@/utils';

function decodeDataComponent(str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
const instance = axios.create({
  baseURL,
  timeout: 300000,
  paramsSerializer(params) {
    // 'indices' | 'brackets' | 'repeat' | 'comma' |
    return qs.stringify(params, { arrayFormat: 'repeat', encode: true });
  },
});

// 加签
instance.interceptors.request.use((request) => {
  console.log(request);
  console.log(request.url);
  console.log(request.params);
  console.log(Object.keys({ id: 3, iconUrl: 'https://cfmoto.oss-cn-hangzhou.aliyuncs.com/IMD/social/Icon/ic_hnl3.png', content: '发帖子分享骑行经历', type: 2, activeFlag: true, abledFlag: true }).sort());
  const appConfig = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_CONFIG`];
  const params = JSON.parse(JSON.stringify(request.params || {}));
  const query = qs.stringify(params, { arrayFormat: 'repeat', encode: false });
  const data = decodeDataComponent(!Object.keys(request.data || {}).length || request.data instanceof FormData ? '' : typeof request.data === 'string' ? request.data : JSON.stringify(request.data || ''));
  const queryError = /error/.test(window.location.href) ? '&error=' + new Date().getTime() : '';
  const nonce = randomUUID();
  const timestamp = new Date().getTime();
  const signature = `${query}${queryError}${data}appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}${appConfig.appSecret}`;
  const signatureMd5 = md5(sha1(signature).toString()).toString();
  const signatureParam = `appId=${appConfig.appId}&nonce=${nonce}&timestamp=${timestamp}`;

  console.log(`=====  加签start =====`);
  console.log(`appId:${appConfig.appId}`);
  console.log(`appSecret:${appConfig.appSecret}`);
  console.log(`params:${JSON.stringify(params)}`);
  console.log(`query:${query}`);
  console.log(`data:`, data);
  console.log(`nonce:${nonce}`);
  console.log(`timestamp:${timestamp}`);
  console.log(`signatureParam:${signatureParam}`);
  console.log(`拼接后：${signature}`);
  console.log(`加密后：${signatureMd5}`);

  // console.log(`=====  加签end =====`)

  request.headers['Cfmoto-X-Sign'] = `${signatureMd5}`;
  request.headers['Cfmoto-X-Sign-Type'] = `0`;
  request.headers['Cfmoto-X-Param'] = `${signatureParam}`;

  /* eslint-enable */
  return request;
});

// token
instance.interceptors.request.use(async (request) => {
  /* eslint-disable */
  const ticket = JSON.parse(localStorage.getItem('token') || '""')
    .replace(/[bB]earer/, '')
    .trim();
  if (ticket && !request.headers['Authorization']) {
    request.headers.common['Authorization'] = `Bearer ${ticket}`;
  } else {
    request.headers.common['Authorization'] = `a1398a17-0890-4ab1-9df3-be9e2aa40615`;
  }
  request.headers['Zeeho-User-Agent'] = getCustomAgent();
  // request.headers['x-app-info'] = getCustomAgent();
  const user_id = JSON.parse(localStorage.getItem('user_id') || '""');
  if (user_id) {
    request.headers.common['user_id'] = user_id;
  }
  // request.headers.common['version'] = config.version;
  request.withCredentials = true;
  /* eslint-enable */
  return request;
});

instance.interceptors.request.use((request) => {
  /* eslint-disable */
  const { pathParams } = request;
  let newUrl = request.url;
  if (pathParams && pathParams instanceof Object) {
    Object.keys(pathParams).forEach((name) => {
      newUrl = newUrl.replace(`\:${name}`, pathParams[name]);
    });
  }

  if (request.method.toUpperCase() === 'POST' && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    request.data = qs.stringify(request.data || {});
  }
  request.url = newUrl;
  return request;
});

instance.interceptors.request.use((request) => {
  /* eslint-disable */
  request.params = request.params || {};
  request.params.server_name = 'SMART';
  return request;
});

if (envConfig.env === 'development') {
  // instance.interceptors.request.use((request) => {
  //   request.baseURL += `/${request.method}`;
  //   return request;
  // });
  instance.interceptors.response.use((response) => {
    /* eslint-disable no-console */
    console.log(`请求${response.config.url.replace(new RegExp(response.config.baseURL), '')}返回的Mock数据:`);
    console.dir(response.data);
    return response;
  });
}

instance.interceptors.response.use(
  async (response) => {
    const { to } = response.config;
    const meta = (to || {}).meta || {};
    // 阻止options
    if (response.config.method.toLowerCase() === 'options') return false;
    // 401：未登录，403 token无效
    if (meta.auth !== 0 && [401, 403].some((code) => code === response.status)) {
      return Promise.reject(response);
    }
    if (![200].some((code) => code === response.status)) return Promise.reject();
    /* eslint-disable  */
    response.data.code = isNaN(response.data.code) ? response.data.code : response.data.code * 1;
    /* eslint-enable */
    return response.data;
  },
  (error) => {
    console.log(error);
    if (error && [401, 403].some((code) => error.message.indexOf(`${code}`) !== -1)) {
      const { to } = error.config || {};
      const meta = (to || {}).meta || {};
      const { protocol, host } = window.location;
      const redirectUrl = to && to.fullPath ? `${protocol}//${host}${to.fullPath}` : window.location.href;
      console.log(redirectUrl);
      // console.log('to:======', error.config);
      localStorage.removeItem('token');
      if (meta.auth !== 0) {
        store.commit(USER_USERINFO_UPDATE, {});
        Toast.fail('登录失效，请重新登录！');
        return Promise.reject(error);
        // instance.router.replace({ name: 'auth.user.login', query: { redirectUrl } });
      }
      return Promise.reject(error);
    }
    if (error.message.indexOf('430') > -1) {
      Toast.fail('签名校验失败');
      return Promise.reject(error);
    }
    if (error.message.indexOf('code 404') > -1) {
      Toast.fail('数据不存在');
      return Promise.reject(error);
    }
    if (error.message.indexOf('timeout of') > -1) {
      Toast.fail('请求超时了');
      return Promise.reject(error);
    }
    // Toast.fail('系统繁忙，请稍候再试！');
    return Promise.reject(error);
  }
);

export default instance;
